<script setup>
import { IKImage } from "imagekitio-vue";
import { pathFromAWSUrl } from '@/imagekit/aws_path'
import { computed } from 'vue'
import { ImageKitURLEndpoint, PublicKey } from '@/imagekit/imageurl_from_aws_url'

const props = defineProps ({
    awsUrl: {
      type: String,
      required: true
    },
    transformation: {
      type: Array,
      default() {
        return []
      }
    },
    queryParameters: {
      type: Object,
      default: () => null
    },
    loading: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    }
  })

const path = computed(() => pathFromAWSUrl(props.awsUrl))
</script>

<template>
  <IKImage
    :urlEndpoint="ImageKitURLEndpoint"
    :publicKey="PublicKey"
    :path="path"
    :query-parameters="queryParameters"
    :transformation="transformation"
    :loading="loading"
    :height="height"
    :width="width" />
</template>

<style scoped>
</style>
